<template>
  <div class="group_info">
    <div class="group_text">
      <ul>
        <li class="group-name">
          <span class="right-info">{{ `Группа ${groupInfo.id}. ${groupInfo.name || ''}` }}</span>
        </li>
      </ul>
    </div>
    <div class="group-actions">
      <ul>
        <li>
          <button class="profile-edit" @click="$emit('edit')">
            <i class="mdi mdi-account-edit"></i> Редактировать группу
          </button>
        </li>
        <li>
          <button class="profile-edit" @click="$emit('delete')">
            <i class="mdi mdi-account-remove-outline"></i> Удалить
          </button>
        </li>
        <li v-if="userRole !== 'leader'">
          <button class="add_branch add_course" @click="$emit('add-course')">
            <i class="mdi mdi-file-document-box-plus-outline"></i> Добавить курс(-ы) группе
          </button>
        </li>
        <li>
          <button class="add_branch add_course" @click="$emit('add-user')">
            <i class="mdi mdi-account-plus-outline"></i> Добавить пользователя(-ей) в группу
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    groupInfo: {
      default: () => {},
      type: Object,
    },
  },
  computed: {
    userRole() {
      return this.$store.state.auth.role[0];
    },
  },
}
</script>
